// Shared by the question screens: list, preview modal and details page.
import { renderContentHtml } from "../utils/richText";

export const MCQ_TYPES = ["Multiple Choice single selection", "Multiple Choice multi selection"];
export const CODE_QUESTION_TYPE = "Code to compile with output";
export const isMCQType = (type) => MCQ_TYPES.includes(type);

// Short labels for the type column and chips.
const TYPE_SHORT = {
  "Multiple Choice single selection": "MCQ · Single",
  "Multiple Choice multi selection": "MCQ · Multi",
  "Code to compile with output": "Code",
  Descriptive: "Descriptive",
  Text: "Text",
};
export const typeLabel = (type) => TYPE_SHORT[type] || type || "—";

export const DIFFICULTY_TONE = {
  Easy: "easy", Medium: "medium", Hard: "hard", "Very Hard": "very-hard", Professional: "professional",
};

// Admin-authored content: rich HTML renders as written, plain text keeps its
// line breaks; /uploads/ image paths point at S3.
export const renderContent = (value) => renderContentHtml(value || "");

export const hasContent = (html) => {
  if (!html) return false;
  if (/<img\s/i.test(html)) return true;
  return String(html).replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim().length > 0;
};

// One-line plain text for previews. Entities are decoded through a detached
// <textarea> so "&lt;" shows as "<" rather than as the entity.
export const plainText = (html) => {
  if (!html) return "";
  const el = document.createElement("textarea");
  el.innerHTML = String(html).replace(/<[^>]*>/g, " ");
  return el.value.replace(/\s+/g, " ").trim();
};

export const formatDateTime = (dt) => {
  if (!dt) return "—";
  const d = new Date(dt);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true });
};

// Titles stored as raw ObjectIds by old imports are not readable names.
const OBJECT_ID_RE = /^[0-9a-fA-F]{24}$/;
export const readable = (value) => {
  const s = value == null ? "" : String(value).trim();
  return s && !OBJECT_ID_RE.test(s) ? s : "";
};

const SECTION_TYPE_LABEL = { example: "Example", quiz: "Quiz", practice: "Practice", assignment: "Assignment", notes: "Notes" };
export const sectionTypeLabel = (type) => SECTION_TYPE_LABEL[type] || type || "";
